"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickAddMenu = void 0;
var mobx_react_1 = require("mobx-react");
var React = require("react");
var buttons_1 = require("../buttons");
var bulkEdit_1 = require("./bulkEdit");
var columns_1 = require("./columns");
var api_1 = require("../../api");
var QuickAddMenu = (function (_super) {
    __extends(QuickAddMenu, _super);
    function QuickAddMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            valuesByField: {},
            buttonsDisabled: false
        };
        return _this;
    }
    QuickAddMenu.prototype.closeMenu = function () {
        this.setState({ buttonsDisabled: false });
        this.props.toggleQuickAdd();
    };
    ;
    QuickAddMenu.prototype.onFieldChange = function (field, value) {
        var _this = this;
        this.setState(function (prevState) {
            var selectedFields = __assign({}, prevState.valuesByField);
            return {
                valuesByField: _this.updateField(selectedFields, field, value),
            };
        });
    };
    QuickAddMenu.prototype.updateField = function (selectedFields, field, value) {
        var name = field.name;
        if (name === 'userdefined')
            name = 'udf_' + field.field_object_id;
        switch (field.type) {
            case columns_1.ColumnTypes.TEXT:
            case columns_1.ColumnTypes.PASSWORD:
            case columns_1.ColumnTypes.NUMBER:
            case columns_1.ColumnTypes.DATE:
            case columns_1.ColumnTypes.USER:
            case columns_1.ColumnTypes.BOOLEAN:
            case columns_1.ColumnTypes.AUTOSUGGEST:
            case columns_1.ColumnTypes.FILE:
                selectedFields[name] = value;
                break;
            case columns_1.ColumnTypes.SELECT:
                if (value === bulkEdit_1.emptyChoice.value)
                    delete selectedFields[name];
                else
                    selectedFields[name] = value;
                break;
            case columns_1.ColumnTypes.CHECKBOXES:
            case columns_1.ColumnTypes.LINKS:
                if (value === null)
                    delete selectedFields[name];
                else if (value instanceof Array)
                    selectedFields[name] = value;
                else if (typeof value == "string")
                    selectedFields[name] = [value];
                break;
            default:
                console.error("Unknown field type");
        }
        return selectedFields;
    };
    QuickAddMenu.prototype.onUpdateSuccess = function (response, opts) {
        var self = this;
        this.props.refetchTable && this.props.refetchTable();
        this.closeMenu();
    };
    ;
    QuickAddMenu.prototype.onUpdateFailed = function (error) {
        api_1.api.apiErrorHandler(error, null, null);
        this.closeMenu();
    };
    QuickAddMenu.prototype.performUpdate = function (opts) {
        var _this = this;
        this.setState({ buttonsDisabled: true });
        this.props.performQuickAdd(this.state.valuesByField)
            .then(function (response) { return _this.onUpdateSuccess.bind(_this)(response, opts); }, this.onUpdateFailed.bind(this));
    };
    QuickAddMenu.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var disabled = this.state.buttonsDisabled;
        return (React.createElement("div", { className: "EditableList__BulkEditMenu" },
            React.createElement("h3", null, gettext("Add Menu")),
            props.fields && props.fields.map(function (field) {
                return (0, bulkEdit_1.dispatchBulkEditField)(field, [], _this.onFieldChange.bind(_this), null, _this.props.quickAddMenuState);
            }),
            React.createElement("p", null),
            React.createElement("div", null,
                React.createElement(buttons_1.PrimaryButton, { onClick: function (e) {
                        _this.performUpdate({});
                    }, className: "mr-1", disabled: disabled },
                    gettext("Save"),
                    " ",
                    disabled &&
                        React.createElement("div", { className: "iconwrapper" },
                            React.createElement("i", { className: "fas fa-spinner fa-spin tabSpinner statusTab" }))),
                React.createElement(buttons_1.CancelButton, { onClick: function (e) { return props.toggleQuickAdd(); } }, gettext("Cancel")),
                " ")));
    };
    QuickAddMenu = __decorate([
        mobx_react_1.observer
    ], QuickAddMenu);
    return QuickAddMenu;
}(React.Component));
exports.QuickAddMenu = QuickAddMenu;
